let eventTable = document.querySelector(".event-table");

if (eventTable) {
  $(".event-table").DataTable({
    responsive: true,
    retrieve: true,
    autoWidth: false,
    "paging": false,
    "pageLength": 25,
    // ajax: ,
    order: [[7, "asc"]],
    language: {
      search: '<i class="fa fa-search"></i>',
      searchPlaceholder: "SEARCH",
    },
  });
}

let pastEventTable = document.querySelector(".past-event-table");

if (pastEventTable) {
  $(".past-event-table").DataTable({
    responsive: true,
    retrieve: true,
    autoWidth: false,
    "paging": false,
    "pageLength": 25,
    order: [[7, "desc"]],
    language: {
      search: '<i class="fa fa-search"></i>',
      searchPlaceholder: "SEARCH",
    },
  });
}

let registrationsTable = document.querySelector("#crystal-registrations-table");
if (registrationsTable) {
  $("#crystal-registrations-table").DataTable({
    responsive: true,
    retrieve: true,
    autoWidth: false,
    order: [[6, "desc"]],
    language: {
      search: '<i class="fa fa-search"></i>',
      searchPlaceholder: "SEARCH",
    },
  });
}

let crystalTable = document.querySelector("#crystal-table");
if (crystalTable) {
  $("#crystal-table").DataTable({
    responsive: true,
    retrieve: true,
    autoWidth: false,
    language: {
      search: '<i class="fa fa-search"></i>',
      searchPlaceholder: "SEARCH",
    },
  });
}

let crystalCamperTable = document.querySelector("#crystal-camper-table");
if (crystalCamperTable) {
  $("#crystal-camper-table").DataTable({
    responsive: true,
    retrieve: true,
    autoWidth: false,
    processing: true,
    serverSide: true,
    ajax: "admin/campers/index.json",
    language: {
      search: '<i class="fa fa-search"></i>',
      searchPlaceholder: "SEARCH",
    },
  });
}

let crystalTableTwo = document.querySelector(".crystal-table");
if (crystalTableTwo) {
  $(".crystal-table").DataTable({
    responsive: true,
    retrieve: true,
    autoWidth: false,
    order: [[3, "desc"]],
    language: {
      search: '<i class="fa fa-search"></i>',
      searchPlaceholder: "SEARCH",
    },
  });
}

let crystalTableThree = document.querySelector(".mail-table");
if (crystalTableThree) {
  $(".mail-table").DataTable({
    responsive: true,
    retrieve: true,
    autoWidth: false,
    language: {
      search: '<i class="fa fa-search"></i>',
      searchPlaceholder: "SEARCH",
    },
  });
}
